import React, {useState} from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../config';
import Translate from '../../../../../components/Translate';
import ConversationList from './ConversationList';
import {tabButtonStyles} from "../../../../../utils/General";

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 80px)',
        padding: '10px',
    },
    countBadge: {
        position: 'absolute',
        top: '-5px',
        right: '-5px',
        backgroundColor: '#FF3636',
        color: '#FFFFFF',
        borderRadius: '50%',
        padding: '3px 8px',
        fontSize: '10px',
    },
    chatContainer: {
        overflowY: 'auto',
        height: '100%',
        marginTop: '10px',
        borderRadius: '5px',
    },
};

const UserConversationListManager = ({
                                         incomingConversations,
                                         endConversationForOperator,
                                         processingConversations,
                                         selectConversation,
                                         selectedConversation,
                                         user,
                                         userData,
                                         openForwardDialog,
                                         blockUserClick,
                                         ticketClick,
                                         forwardConversation,
                                         company,
                                         loadOlderMessages,
                                         clearSelectedConversationFromStore
                                     }) => {
    const [activeTab, setActiveTab] = useState('processing');

    const processingChats = processingConversations.filter(p => p.operatorId != null).filter(p => p.operatorId == userData.id);
    const supervisorChats = processingConversations.filter(p => p.operatorId != null).filter(p => p.operatorId != userData.id);

    const incomingCount = incomingConversations.length;
    const processingCount = processingChats.length;
    const supervisorCount = supervisorChats.length;

    return (
        <div style={styles.container}>
            <div style={{...tabButtonStyles.tabButtons, marginBottom: '0px', marginTop: '0px'}}>
                <button style={tabButtonStyles.tabButtonBackgroundSilver(activeTab === 'incoming')}
                        onClick={() => setActiveTab('incoming')}>
                    <Translate text="incomingChats"/>
                    {incomingCount !== 0 && (
                        <span style={styles.countBadge}>{incomingCount}</span>
                    )}
                </button>
                <button style={tabButtonStyles.tabButtonBackgroundSilver(activeTab === 'processing')}
                        onClick={() => setActiveTab('processing')}>
                    <Translate text="processingChats"/>
                    {processingCount !== 0 && (
                        <span style={styles.countBadge}>{processingCount}</span>
                    )}
                </button>
                {(user.authorities.includes(config.rolesMap.owner) || user.authorities.includes(config.rolesMap.admin)) && (
                    <button style={tabButtonStyles.tabButtonBackgroundSilver(activeTab === 'supervisor')}
                            onClick={() => setActiveTab('supervisor')}>
                        <Translate text="supervisor"/>
                        {supervisorCount !== 0 && (
                            <span style={styles.countBadge}>{supervisorCount}</span>
                        )}
                    </button>
                )}
            </div>

            <div style={styles.chatContainer}>
                {activeTab === 'incoming' && (
                    <div style={{height: '100%', overflow: 'auto'}}>
                        <ConversationList
                            id="chat-incoming-list"
                            conversationList={incomingConversations}
                            contactsNameSpace={config.contactsNameSpaces.incomings}
                            selectConversation={selectConversation}
                            selectedConversation={selectedConversation}
                            endConversationForOperator={endConversationForOperator}
                            user={user}
                            ticketClick={ticketClick}
                            blockUserClick={blockUserClick}
                            openForwardDialog={openForwardDialog}
                            forwardConversation={forwardConversation}
                            company={company}
                            loadOlderMessages={loadOlderMessages}
                            clearSelectedConversationFromStore={clearSelectedConversationFromStore}
                        />
                        <br/>
                        <br/>
                        <br/>
                    </div>
                )}
                {activeTab === 'processing' && (
                    <div style={{height: '100%', overflow: 'auto'}}>
                        <ConversationList
                            id="chat-conversations-list"
                            conversationList={processingChats}
                            contactsNameSpace={config.contactsNameSpaces.conversations}
                            selectConversation={selectConversation}
                            selectedConversation={selectedConversation}
                            endConversationForOperator={endConversationForOperator}
                            user={user}
                            ticketClick={ticketClick}
                            blockUserClick={blockUserClick}
                            openForwardDialog={openForwardDialog}
                            forwardConversation={forwardConversation}
                            company={company}
                            loadOlderMessages={loadOlderMessages}
                            clearSelectedConversationFromStore={clearSelectedConversationFromStore}
                        />
                        <br/>
                        <br/>
                        <br/>
                    </div>

                )}
                {activeTab === 'supervisor' && (
                    <div style={{height: '100%', overflow: 'auto'}}>
                        <ConversationList
                            id="chat-supervisor-list"
                            conversationList={supervisorChats}
                            contactsNameSpace={config.contactsNameSpaces.conversations}
                            selectConversation={selectConversation}
                            selectedConversation={selectedConversation}
                            endConversationForOperator={endConversationForOperator}
                            user={user}
                            isSupervisor={true}
                            ticketClick={ticketClick}
                            blockUserClick={blockUserClick}
                            openForwardDialog={openForwardDialog}
                            forwardConversation={forwardConversation}
                            company={company}
                            loadOlderMessages={loadOlderMessages}
                            clearSelectedConversationFromStore={clearSelectedConversationFromStore}
                        />
                        <br/>
                        <br/>
                        <br/>
                    </div>
                )}
            </div>
        </div>
    );
};

UserConversationListManager.propTypes = {
    incomingConversations: PropTypes.array.isRequired,
    processingConversations: PropTypes.array.isRequired,
    selectConversation: PropTypes.func.isRequired,
    selectedConversation: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
};

export default UserConversationListManager;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/UserConversationListManager.jsx